var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',[_vm._v("Loading...")]):_c('router-view',{directives:[{name:"c-emit-root-event",rawName:"v-c-emit-root-event:update-close-popup",arg:"update-close-popup"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }